import React, { useEffect, useState, useMemo, useRef } from 'react';
import { AgGridReact } from 'ag-grid-react';
import '@ag-grid-community/styles/ag-grid.css';
import '@ag-grid-community/styles/ag-theme-quartz.css';
import {
  Header,
} from '@backstage/core-components';
import 'ag-grid-enterprise';
import Loader from '../loader/Loader';
import { discoveryApiRef, useApi, fetchApiRef, identityApiRef} from '@backstage/core-plugin-api';
import '../NoteCustomstyle.css';

// Material UI dropdown
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

const UnusedVolumes = () => {
  const gridRef = useRef<any>(null);
  const containerStyle = useMemo(() => ({ width: "100%", height: "100vh" }), []);
  const gridStyle = useMemo(() => ({ height: 'calc(-200px + 80vh)', width: "100%", marginTop: '50px' }), []);
  const [rowData, setRowdata] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [org, setOrg] = useState('');
  const [tenantName, settenantName] = useState<string>(''); // dropdown state
  const [role, setRole] = useState<string>(''); // role state
  const discoveryApi = useApi(discoveryApiRef);
  const fetchApi = useApi(fetchApiRef);
  const [tenantsFromDb, setTenantsFromDb] = useState<any[]>([]);
  const identityApi = useApi(identityApiRef)
  
  const fetchTenantsFromDb = async () => {
    try {
      const baseUrl = await discoveryApi.getBaseUrl('user');
      const response = await fetchApi.fetch(`${baseUrl}/tenants`);
      if (!response.ok) throw new Error("Failed to fetch tenants");
      return await response.json();
    } catch (e) {
      console.error("Error fetching tenants:", e);
      return [];
    }
  };

  const fetchTenant = async () => {
    try {
      const details = await identityApi.getBackstageIdentity();
      const id = details.ownershipEntityRefs.find(ref =>
        ref.startsWith('tenantId:')
      )?.split(':')[1] || null;

      console.log("ID ---------", id)
      return id
    } catch (err) {
      console.error('Failed to get tenantId:', err);
    }
  }; 

  useEffect(() => {
    const fetchData = async () => {
      try {
        const tenants = await fetchTenantsFromDb();
        const id = await fetchTenant()
        console.log(`orgName:${id}`)
        const tenantOrgName = localStorage.getItem(`orgName:${id}`);
        console.log('tenantOrgName------',tenantOrgName)
        if (tenantOrgName) setOrg(tenantOrgName);
        setTenantsFromDb(tenants);
        const baseurl = await discoveryApi.getBaseUrl('user');
        let responseData: any = [];

        try {
          const fetchresponse = await fetchApi.fetch(`${baseurl}/unusedvolumes`, {
            method: 'POST',
          });
          if (!fetchresponse.ok) {
            const errorText = await fetchresponse.text();
            throw new Error(`API error: ${fetchresponse.status} - ${errorText}`);
          }
          const response = await fetchresponse.json();
          responseData = response.data || response;
          setRole(response.role || ""); // role if backend sends it
          console.log('Fetched data:', responseData);
        } catch (error) {
          console.error('Fetch or JSON parse error:', error);
        }

        setRowdata(responseData);
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };

    fetchData();
    let orgName = localStorage.getItem('orgName')
    if (orgName) {
      setOrg(orgName)
    }
  }, [])

  const columnDefs = useMemo(() => {
    const baseCols = [
    { headerName: "Tenant Name", field: "tenantName", headerTooltip: "Tenant Name", rowGroup: true },
    {
      headerName: "Account Id", field: "accountId", headerTooltip: "Account Id", rowGroup: true, valueFormatter: params => {
        if (params.node.rowIndex === params.api.getDisplayedRowCount() - 1 && !params.value) {
          return 'Total';
        }
        else {
          return params.value;
        }
      }
    },
    { headerName: "Region", field: "region", headerTooltip: "Region" },
    { headerName: "VolumeId Id", field: "VolumeId", headerTooltip: "VolumeId Id" },
    { headerName: "Volume Type", field: "VolumeType", headerTooltip: "Volume Type" },
    { headerName: "Size (GB)", field: "size", headerTooltip: "size" },

    {
      headerName: "Cost in $ (per GB per month)", field: "cost", headerTooltip: "Cost in $ (per GB per month)", aggFunc: 'sum', valueFormatter: params => {
        const value = parseFloat(params.value);
        if (!isNaN(value))
          return value.toFixed(2);
      },
    },
  ];
  
  return baseCols.map(col =>
    col.field === "tenantName"
      ? { ...col, hide: role != "SuperAdmin", rowGroup: role != "SuperAdmin" ? false : col.rowGroup }
      : col
  );
}, [role]);

  const defaultColDef = useMemo(() => {
    return {
      flex: 1, filter: true, sortable: true, resizable: true, enableRowGroup: true, tooltipShowDelay: 0, tooltipInteraction: true, columnMenu: "new"
    };
  }, []);

  const autoGroupColumnDef = {
    minWidth: 250,
    cellRendererParams: {
      footerValueGetter: (params) => {
        const isRootLevel = params.node.level === -1;
        if (isRootLevel) {
          return "Potential Cost Savings";
        }
        return " Sub Total";
      },
    },
  };

  const sideBar = {
    toolPanels: [
      {
        id: 'columns',
        labelDefault: 'Columns',
        labelKey: 'columns',
        iconKey: 'columns',
        toolPanel: 'agColumnsToolPanel',
      }
    ],
    defaultToolPanel: '',
  };

  const gridOptions = { suppressContextMenu: true };

  // filter data based on tenantName
  const filteredData = tenantName
    ? rowData.filter(row => String(row.tenantName) === String(tenantName))
    : rowData;

  // unique tenants for dropdown
  const tenants = [...new Set(rowData.map(r => r.tenantName))];
  console.log("Tenants in dropdown:", tenants);

  return (
    <div style={containerStyle}>
      <div>
        <Header title="Unused Volumes" subtitle={`${org}`} />
      </div>

      {/* Dropdown only if role is superadmin */}
      {role === "SuperAdmin" && (
        <div style={{ display: "flex", justifyContent: "flex-end", margin: "10px 0" }}>
          <FormControl variant="outlined" size="small" style={{ minWidth: 200 }}>
            <InputLabel></InputLabel>
            <Select
              value={tenantName}
              onChange={(e) => settenantName(e.target.value)}
              displayEmpty
              MenuProps={{
                PaperProps: {
                  sx: {
                    // force vertical stacking
                    '& .MuiList-root': {
                      display: 'flex !important',
                      flexDirection: 'column !important',
                    },
                    // force left-aligned text inside items
                    '& .MuiMenuItem-root': {
                      justifyContent: 'flex-start',
                      pl: 2,
                    },
                  },
                },
              }}
            >
              <MenuItem value="">All Tenants</MenuItem>
              {tenantsFromDb.map((tenant) => (
                <MenuItem key={tenant.id} value={tenant.name}>
                  {tenant.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      )}

      {loading ? (<Loader />) : (
        <div>
          <div className="ag-theme-quartz resourcecost" style={{ ...gridStyle, marginTop: 10 }}>
            <AgGridReact
              ref={gridRef}
              rowData={filteredData}
              columnDefs={columnDefs}
              autoGroupColumnDef={autoGroupColumnDef}
              rowGroupPanelShow={"always"}
              sideBar={sideBar}
              defaultColDef={defaultColDef}
              groupIncludeFooter={true}
              groupIncludeTotalFooter={true}
              groupDefaultExpanded={-1}
              suppressAggFuncInHeader={true}
              gridOptions={gridOptions}
            />
          </div>
          <div className="recommended-action-container">
            <div className="scroll-container">
              <strong>Recommended Action</strong>
              <ul>
                <li>
                  <strong>Reallocate Unused EBS Volumes to Cost-Effective Storage</strong>
                  <p>Managing unused EBS volumes helps reduce costs by freeing up resources that are no longer in use. Here’s how to approach it:</p>
                  <ul>
                    <li>Identify Unused Volumes: Check for EBS volumes that are not attached to any EC2 instances in the EC2 Dashboard.</li>
                    <li>Evaluate Usage: Determine if the unused volumes are indeed no longer needed or if they are required for future use, backups, or disaster recovery.</li>
                    <li>For volumes that are unnecessary, select the unused volumes and delete them to stop incurring costs. For volumes that are infrequently used but necessary, consider downsizing the volume type.</li>
                  </ul>
                  <p>Considerations:</p>
                  <ul>
                    <li>Ensure that you do not delete volumes that contain critical data or backups. Regularly review unused volumes to optimize costs and avoid paying for resources that are not in use.</li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
          <div className="note-container">
            <p>
              <strong>Note*</strong><span className="note-text">: To estimate potential cost savings for EBS volumes, the cost of the current storage type (e.g., gp3, io2) was calculated by multiplying the volume size by the cost per GB. This cost was then compared with a lower-cost storage class (e.g., gp2, st1), considering additional charges for IOPS and throughput where applicable. For io1 and io2 volumes, savings were assessed by comparing current costs with those of alternative storage options.</span>
            </p>
          </div>
        </div>
      )}
    </div>
  )
}

export default UnusedVolumes;
